<h3 class="leave-confirm__title typography-title">Cancel Auto Bet?</h3>
<p class="leave-confirm__description">Leaving the page will cancel Auto Bet.</p>
<div class="leave-confirm__actions">
  <button class="leave-confirm__btn leave-confirm__btn--cancel" (click)="cancel()">Cancel</button>
  <button class="leave-confirm__btn leave-confirm__btn--leave" (click)="leave()">Leave</button>
</div>
